import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Visit, VisitsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class VisitsDataService {

  private uri: string = `${environment.apiUrl}visits`;
  private cacheKey: string = 'visits.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getVisit(id: number): Observable<Visit|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getVisits(parameters: {[param: string]: string | string[]}): Observable<VisitsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addVisit(data: Visit): Observable<Visit|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addVisits(data: Visit[]): Observable<Visit[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateVisit(data: Visit): Observable<Visit|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateVisits(data: Visit[]): Observable<Visit[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchVisit(data: Visit): Observable<Visit|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchVisits(data: Visit[]): Observable<Visit[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteVisit(data: Visit): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteVisits(data: Visit[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((visit) => {
      ids.push(visit.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
